
import { Component, Vue } from 'vue-property-decorator'
import { AdminApi } from '@/wwapi/apis/admin-api'
import { cloneDeep } from 'lodash'
import { Form } from 'element-ui'
import { GetSubjectsResponse } from '@/wwapi/models/get-subjects-response'
import { defaultSubjectData } from '../../defaultModels/ISubjectData'

@Component({
  name: 'SubjectList'
})
export default class extends Vue {
  private list: GetSubjectsResponse[] = [];
  private showFullDescription: Array<any> = [];
  private listLoading = true;
  private dialogFormVisible = false;
  private deleteConfirmationVisible = false;
  private deleteItemId = null;
  private dialogStatus = '';
  private tempSubjectData = defaultSubjectData;
  private textMap = {
    update: 'Edit',
    create: 'Create'
  };

  private rules = {};

  created() {
    this.fetchData()
  }

  private async fetchData() {
    this.listLoading = true
    const adminApi = new AdminApi()
    const response = await adminApi.getSubjects(true)
    console.log(response)
    if (response.data.data.length) this.list = response.data.data
    else this.list = []
    console.log(
      'data returned from getSubjects' + JSON.stringify(response.data.data)
    )
    setTimeout(() => {
      this.listLoading = false
    }, 0.5 * 1000)
  }

  private handleUpdate(row: any) {
    this.tempSubjectData = Object.assign({}, row)
    this.dialogStatus = 'update'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate()
    })
  }

  private updateData() {
    const adminApi = new AdminApi();
    (this.$refs.dataForm as Form).validate(async(valid) => {
      if (valid) {
        const tempData = Object.assign({}, this.tempSubjectData)
        const { data } = await adminApi.updateSubject({
          id: tempData.id,
          name: tempData.name,
          region: tempData.region,
          isActive: tempData.isActive
        })
        const index = this.list.findIndex((v: any) => v.id === tempData.id)
        if (data.status.code === 'success') {
          this.list.splice(index, 1, tempData)
          this.dialogFormVisible = false
          this.$notify({
            title: 'Success',
            message: 'Successfully update the subject',
            type: 'success',
            duration: 2000
          })
        }
      }
    })
  }

  private handleCreate() {
    this.tempSubjectData = cloneDeep(defaultSubjectData)
    this.dialogStatus = 'create'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate()
    })
  }

  private createData() {
    const adminApi = new AdminApi();

    (this.$refs.dataForm as Form).validate(async(valid) => {
      if (valid) {
        const tempData = Object.assign({}, this.tempSubjectData)
        const { data } = await adminApi.createSubject({
          name: tempData.name,
          region: tempData.region,
          isActive: tempData.isActive
        })
        if (data && data.data) {
          this.list = [...this.list, data.data]
        }
        this.dialogFormVisible = false
        this.$notify({
          title: 'Success',
          message: 'Successfully added new subject',
          type: 'success',
          duration: 2000
        })
      }
    })
  }

  private async toggleSubjectActive(row: any, isActive: boolean) {
    const adminApi = new AdminApi()
    const { data } = await adminApi.updateSubject({
      id: row.id,
      name: row.name,
      region: row.region,
      isActive: isActive
    })
    if (data.status.code === 'success') {
      row.isActive = isActive
      this.$notify({
        title: 'Success',
        message: 'Successfully subject status changed',
        type: 'success',
        duration: 2000
      })
    }
  }
}
